import Scorecard from '../Scorecard';
function MobileLeaderboard({
    event,
    nameFilter,
    divFilter,
    typeFilter,
    entries
}) {

    const filteredResults = function(){
        return entries.filter((v) => {
            return (typeFilter && (typeFilter === 'All' || v.entry_type === typeFilter)) &&
            ((divFilter === undefined) || v.division === divFilter) &&
            ((nameFilter === '' || v.display_name.toLowerCase().indexOf(nameFilter.toLowerCase()) > -1)) 
        }).map((v, i) => {
            return <Scorecard name={ v.display_name}
                overallRank={v.rank} 
                typeRank={v.typeRank}
                totalScore={v.totalScore} 
                puzzleResults={v.solves}
                puzzles={event.puzzles}
                clean={v.clean}
                division={v.division}
                type={v.entry_type}
                typeFilter={typeFilter}/>
            }
        );
    }
        

    
    return (
        <>
            {filteredResults()}
        </>
    )
}

export default MobileLeaderboard;